import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-workreport-dialog',
  templateUrl: './create-workreport-dialog.component.html',
  styleUrls: ['./create-workreport-dialog.component.css']
})
export class CreateWorkreportDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
